var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"n-icons/outline/search"},React.createElement("path",{"id":"Vector","d":"M17.9226 17.9222L13.3337 13.3333M8.33366 15C12.0156 15 15.0003 12.0152 15.0003 8.33329C15.0003 4.65139 12.0156 1.66663 8.33366 1.66663C4.65176 1.66663 1.66699 4.65139 1.66699 8.33329C1.66699 12.0152 4.65176 15 8.33366 15Z","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round"})));
}

SearchIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
